// extracted by mini-css-extract-plugin
export default {"adButton":"ad-button_adButton__nu6qu","countContainer":"ad-button_countContainer__Poh6E"};